import BlankPhoto from "../images/projects/BlankPhoto.png";
import BlankPhoto2 from "../images/projects/BlankPhoto.png";
// import theBestOfUs from '../images/theBestOfUs.png';
//"../images/projects/ecobuddy.png"
export const ProjectsData = {
  projects: [
    {
      id: 1,
      imgSrc: BlankPhoto2,
      title: "{Include Project Title Here}",
      desc: "Breif Description on what the project is about",
      info: "This is where you'll input the project details, time frames, and Key Features. Mention the importance of the project!",
      skillsHeader: "Key Skills",
      skills: "React, HTML, CSS, JavaScript, Python, Django {Change to your skills}",
      buttonOne: "Follow on Instagram",
      buttonTwo: "Visit Website",
      code: "Your Code Link",
      visit: "Your Code Link",
    },
    {
      id: 2,
      imgSrc: BlankPhoto,
      title: "{Include Project Title Here}",
      desc: "Breif Description on what the project is about",      
      info: "This is where you'll input the project details, time frames, key features. Mention the importance of the project!",
      skillsHeader: "Key Skills",
      skills: "Solidity, React, Redux {Change to your skills}",
      buttonOne: "View Project Code",
      buttonTwo: "Visit Website",
      code: "Your Code Link",
      visit: "Your Code Link",
    },
    // {
    //   id: 3,
    //   imgSrc: theBestOfUs,
    //   title: "The Best Project",
    //   desc: "Portfolio Project",
    //   info: "Built a portfolio project to showcase my skills and projects.",
    //   skillsHeader: "Key Skills",
    //   skillsOne: "React",
    //   skillsTwo: "JavaScript",
    //   skillsThree: "CSS - Styled Components",
    //   buttonOne: "View Code",
    //   buttonTwo: "Visit Project",
    //   code: "https://github.com/boldmotive/",
    //   visit: "https://pensight.com/x/boldmotive",
    // },
  ],
};
